import React from 'react';

import * as MixPanel         from '../mixpanel';
import { getShortDate }      from '../time-helpers';
import * as Actions          from '../../context/ctx-actions';
import { useGlobalCtx }      from '../../context/ctx-hook';
import * as ProductSelectors from '../../context/selectors/product-selectors';
import { getUserId }         from '../../context/selectors/user-selectors';
// import { checkRebrandName }  from '../../helpers/pure-functions';
// import { ProductName } from '../../components/common/product/prod-name';

import {
  filterSimpSubs,
  createSubscriptionMap,
  transformHistoryMap,
  checkRebrandName,
} from '../pure-functions';

import * as NetworkCalls     from '../../network/network-calls';

export const useAutoRenew = (product, autoRenew = false, txnId=false, onClose)  => {
  const {globalDispatch, state} = useGlobalCtx();
  const IS_BUNDLE = product === 'bundle';
  const SUB = IS_BUNDLE ? ProductSelectors.getSubscription(state, product, txnId) : ProductSelectors.getSubscription(state, product);
  const SUB_DATA = IS_BUNDLE ? SUB?.bundleSub : SUB;
  const BUNDLE_NAME = IS_BUNDLE ? SUB?.bundleSkuData?.display_name : false;
  // const SUB_NAME = IS_BUNDLE ? false : <ProductName sub={product} nameStyle={'textOnly'} />;
  const SUB_EXPIRE_ON = SUB_DATA?.expireOn || '';

  // console.log('product:', product);
  // console.log('SUB:', SUB);
  // console.log('SUB_DATA:', SUB_DATA);
  // console.log('BUNDLE_NAME:', BUNDLE_NAME);
  // console.log('SUB_NAME:', SUB_NAME);

  return async () => {
    try {
      globalDispatch(Actions.setCtxField('isDisabled', true));

      const {data} = await NetworkCalls.callUpdateAutoRenewV2({
        userId: getUserId(state),
        bundleTxId: txnId,
        product,
        autoRenew
      });

      // let SUB_NAME = data.postState.productName;
      // if (SUB_NAME == 'Simplifi') {
      // SUB_NAME = ProductSelectors.simplifiTierDisplayName(SUB.tierName, 'fullname');
      // } else {
      // checkRebrandName(SUB_NAME);
      // }

      MixPanel.track(MixPanel.MIX_PANEL_IDS.AUTO_RENEW);

      // if(data?.postState) {
      // const updatedHistory = await NetworkCalls.callGetHistories();
      // const HISTORY_MAP = transformHistoryMap(updatedHistory);

      const subResponseYetAgain = await NetworkCalls.callGetSubscriptions();
      const SUB_MAP = filterSimpSubs(createSubscriptionMap(subResponseYetAgain.data, state.skus));
      const SUB_NAME = data?.postState?.productName || '';
      // console.log(state);
      // console.log(SUB_MAP);

      globalDispatch(Actions.mergeMainStateObj({
        isDisabled: false,
        // subscriptions: ProductSelectors.mergeSubscription(state, product, data.postState),
        subscriptions: SUB_MAP,
        // history: HISTORY_MAP,
        alert: {
          type: 'SUCCESS',
          messages: autoRenew
            ? [
              'Your membership is now set up!',
              `Your ${IS_BUNDLE ? BUNDLE_NAME : SUB_NAME} renewal date is ${getShortDate(SUB_EXPIRE_ON)}`
            ] : [
              `You can continue using ${IS_BUNDLE ? BUNDLE_NAME : SUB_NAME} until your subscription expires.`,
              'You can turn auto-renew on by clicking \'Set to Renew Automatically\' next to the product information.'
            ]
        },
      }));
      // console.log(state);

      // }

      if(onClose) {
        onClose();
      }
    } catch (err) {
      console.log(err);
      MixPanel.error(err, MixPanel.MIX_PANEL_IDS.AUTO_RENEW);
      globalDispatch(Actions.setCtxField('isDisabled', false));
    }
  };
};
